<template>
    <el-dialog :visible.sync="form_state" title="Массовая рассылка СМС" :append-to-body="true" width="450px">
        <form @submit.prevent="send" v-loading="form.busy">
            <div class="form-row">
                <div class="form-group col-12">
                    <label class="mb-1" :for="'template' + _uid">Шаблон</label>
                    <Select2 v-model="template" :options="templates_select" :id="'template' + _uid" :settings="{width: '100%'}" :class="{ 'is-invalid': form.errors.has('template') }" />
                    <has-error :form="form" field="template"/>
                </div>
                <div class="form-group col-12">
                    <label class="mb-1" for="text">Текст</label>
                    <textarea class="form-control" rows="6" v-model="text" id="text" :class="{ 'is-invalid': form.errors.has('text') }"></textarea>
                    <has-error :form="form" field="text"/>
                </div>
                <div class="form-group col-12">
                    <v-button :loading="form.busy" :large="false" :type="'primary'" >Отправить ({{ids.length}})</v-button>
                </div>
            </div>
        </form>
    </el-dialog>
</template>

<script>
import Form from "vform";
import toastr from "toastr";

export default {
    name: "BulkSMS",
    data: () => ({
        ids: [],
        form_state: false,

        template: 0,
        templates: [],
        text: '',
        form: new Form(),
    }),
    mounted() {
        let self = this;
        this.$bus.$on('bulk-sms:open-form', ids => {
            self.ids = ids;
            self.form_state = true;
        });
    },
    beforeDestroy() {
        this.$bus.$off('bulk-sms:open-form');
    },
    computed: {
        templates_select() {
            let items = this.templates.map(t => ({id: t.id, text: t.name}));
            items.unshift({id: 0, text: 'Выберите шаблон', disabled: true});
            return items;
        }
    },
    watch: {
        template: function (val) {
            if (val) {
                let search = _.find(this.templates, {id: +val});
                if (search) this.text = search.text;
            }
        },
        form_state(val) {
            this.resetData();
            if (val) {
                this.fetchTemplates();
            }
        }
    },
    methods: {
        async send () {
            let self = this;
            if (this.validate()) {
                this.form.text = this.text;
                this.form.ids = this.ids;

                this.form.post('/api/request_sms_messages/bulk')
                    .then(r => {
                        self.$message.success({
                            message: 'СМС отправлены',
                            duration: 2000,
                        });
                        self.resetData();
                        self.form_state = false;
                    });
            }
        },
        resetData() {
            this.text = '';
            this.template = 0;
            this.templates = [];
            this.form = new Form();
        },
        validate: function () {
            this.form = new Form();
            if (this.text.length <= 0) {
                this.form.errors.set('text', ['Текст не может быть пустым']);
                return false;
            }
            return  true;
        },
        fetchTemplates() {
            let self = this;
            axios.get('/api/request_sms_templates')
                .then(function (response) {
                    let temps = [];
                    response.data.forEach(function (item) {
                        temps.push(item)
                    });
                    self.templates = temps;
                })
        },
    }
}
</script>

<style scoped>

</style>
